export * from './tax.model';
export * from './tax.service';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/tax/index.ts